<div class="commentlist-container">
  <div class="commentlist-header"> 
    @if (isCommentListExpanded) {
      Comments to {{canvasObjectType}} {{comments.length}}
      <i class="fluent--triangle-down-12-filled ms-2 pointer" (click)="toggleCommentList()"></i>
    } @else {
      <span>
        <span class="mdi--comment-text-outline"></span>
        {{comments.length}}
      </span>
      <i class="fluent--triangle-right-12-filled ms-2 pointer" (click)="toggleCommentList()"></i>
    }
    <app-emoticons [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [contentKey]="contentKey" [canvasObjectKey]="canvasObjectKey"></app-emoticons>
  </div>
  @if (isCommentListExpanded) {
  <div  class="commentlist-body">
    @for (comment of comments; track comment.key) {
    <div class="commentlist-body-comment">
      <div class="commentlist-body-comment-header">
        <div class="commentlist-body-comment-header-date">{{comment.dateOfCreation | date:'medium'}}</div>
        <div class="commentlist-body-comment-header-user">
          @if (comment.userImageURL) {
            <img [src]="comment.userImageURL" class="commentlist-body-comment-header-user-image">
          }
          <span>{{comment.userName}}</span>
        </div>
      </div>
      <div class="commentlist-body-comment-content">
        @if (comment.userId == userId) {
          @if (editedCommentKey == comment.key) {
            <app-addcomment [organizationKey]="organizationKey" [projectKey]="projectKey" [contentKey]="contentKey" [userDisplayName]="userName" [userId]="userId" [newComment]="false"  [doAddCover]="false" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel" [canvasObjectType]="canvasObjectType" [canvasObjectKey]="canvasObjectKey" [commentContent]="comment.content" (onAddComment)="addComment($event)" (areCanvasEventsSuspended)="onCanvasEventsSuspended($event)" (onEditorClosed)="onEditorClosed()"></app-addcomment>
          } @else {
            <div class="commentlist-body-comment-content-text pointer" [innerHTML]="comment.content" (click)="onCommentClicked(comment)"></div>
          }
        } @else {
          <div class="commentlist-body-comment-content-text" [innerHTML]="comment.content"></div>
        }
      </div>
    </div>
    }
    @if (editedCommentKey == "") {
      <app-addcomment [organizationKey]="organizationKey" [projectKey]="projectKey" [contentKey]="contentKey" [userDisplayName]="userName" [userId]="userId" [newComment]="true"  [doAddCover]="true" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel" [canvasObjectType]="canvasObjectType" [canvasObjectKey]="canvasObjectKey" (onAddComment)="addComment($event)" (areCanvasEventsSuspended)="onCanvasEventsSuspended($event)"></app-addcomment>
    }
  </div>
  }
  <div class="position-relative" #commentListBody></div>
</div>
